// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"e53c6a99","45":"5b0f36c3","424":"6a444ac9","428":"9d6bba5a","474":"7cb17506","493":"107c6498","845":"9f327fc8"}[chunkId] + ".chunk.css";
};